<template>
  <div class="space-y-3">
    <h1 class="text-base font-semibold text-text lg:sr-only">Analysis Custom Fields</h1>

    <!-- Methodology tabs + editor -->
    <div class="bg-background-card rounded-lg shadow-card p-6 space-y-4">
      <div class="flex flex-wrap">
        <SelectButton
          v-model="selectedMethod"
          :options="methodOptions"
          option-label="label"
          option-value="value"
          :allow-empty="false"
          aria-label="Methodology"
        />
      </div>
      <MethodologyCustomFieldsEditor :method="selectedMethod" />
    </div>
  </div>
</template>

<script setup lang="ts">
import SelectButton from 'primevue/selectbutton';
import type { MethodologyFieldSchemaMethod } from '@/shared/services/methodologyFieldSchemas';
import MethodologyCustomFieldsEditor from '@/features/maintenance/components/settings/MethodologyCustomFieldsEditor.vue';

definePage({ meta: { requiresProject: true, title: 'Analysis Custom Fields' } });

const selectedMethod = ref<MethodologyFieldSchemaMethod>('Rcm');

const methodOptions: Array<{ label: string; value: MethodologyFieldSchemaMethod }> = [
  { label: 'RCM', value: 'Rcm' },
  { label: 'FMEA', value: 'Fmea' },
  { label: 'RBI', value: 'Rbi' },
  { label: 'SIL', value: 'Sil' },
  { label: 'GMS', value: 'Gms' },
  { label: 'OPS', value: 'Ops' },
  { label: 'OEM', value: 'Oem' },
];
</script>

<style scoped>
:deep(.p-selectbutton) {
  flex-wrap: wrap;
}
</style>
